import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProgressSpinnerService } from '@shared/services/progress-spinner.service';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';

@Injectable()
export class SpinnerLoaderInterceptor implements HttpInterceptor {
  private requestCount = 0;
  private readonly SPINNER_NAME: string = 'x-frontend-spinner-loader';

  constructor(protected spinner: ProgressSpinnerService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.headers.has(this.SPINNER_NAME)) {
      const modifiedReq = request.clone({
        headers: request.headers.delete(this.SPINNER_NAME)
      });

      if (this.requestCount === 0) {
        this.spinner.showSpinner();
      }

      this.requestCount++;

      return next.handle(modifiedReq).pipe(
        catchError((error) => {
          this.spinner.hideSpinner();
          return throwError(() => error);
        }),
        finalize(() => {
          this.requestCount--;
          if (!this.requestCount) {
            this.spinner.hideSpinner();
          }
        })
      );
    }

    return next.handle(request);
  }
}
